var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "margin-right-20 margin-right-s-0" },
    [
      _c(
        "button",
        {
          staticClass:
            "button button--primary button--medium width-s-100 margin-bottom-s-20",
          attrs: { type: "button", "data-gtm": _vm.dataGtm },
          on: {
            click: function ($event) {
              return _vm.clickModalButton(!_vm.isOpen)
            },
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              return _vm.clickModalButton(!_vm.isOpen)
            },
          },
        },
        [
          _vm._v("\n        " + _vm._s(_vm.buttonTitle) + "\n        "),
          _c(
            "svg",
            {
              staticClass: "marketDirectoryArrow margin-left-10",
              attrs: { width: "10", height: "10", "aria-hidden": "true" },
            },
            [_c("use", { attrs: { href: "#iconChevronRightSmall" } })]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "Modal",
        {
          attrs: {
            "modal-open": _vm.isOpen,
            "has-overlay": false,
            "custom-container-classes": _vm.getContainerClasses,
            "custom-close-button-classes": _vm.closeButtonClasses,
          },
          on: { "toggle-modal": _vm.toggleModal },
        },
        [
          _vm.marketData
            ? _c("MarketDirectory", {
                attrs: {
                  "market-data": _vm.getMarketDirectoryData,
                  "active-outlook": _vm.activeOutlook,
                  "is-open": _vm.isOpen,
                },
              })
            : _c("RegionsDirectory", { attrs: { "is-open": _vm.isOpen } }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }